export function isTenant() {
  const { token } = this.getToken()
  if (token == null) return false

  let result = false

  const decodedToken = JSON.parse(atob(token.split('.')[1]))

  const tenant = decodedToken['khoala-claim:istenant']

  if (tenant !== undefined) {
    result = true
  }

  return result
}
